import { Controller } from "@hotwired/stimulus";

import { post } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

export default class extends Controller {
    static values = {
        endpoint: String,
        recipientId: Number,
        redirectUrl: String,
    }

    async start(event) {
        event.preventDefault()
        if (!this.hasEndpointValue || !this.hasRecipientIdValue || !this.hasRedirectUrlValue) {
            return
        }

        try {
            const data = await post(this.endpointValue, {recipient_id: this.recipientIdValue})
            if (data?.id) {
                const url = new URL(this.redirectUrlValue, window.location.origin)
                url.searchParams.set('conversation', data.id)
                window.location.href = url.toString()
            }
        } catch (error) {
            showToast(error.message || 'Не удалось открыть диалог')
        }
    }
}
